import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { withRouter } from '@americanexpress/one-app-router';
import { connectAsync } from 'iguazu';
import MerchantMaps from '@americanexpress/one-maps-base/lib/components/layouts/MerchantMaps';
import loadModuleData, { loadDataAsProps, reducer } from './config/load';

/**
 * Converts our module to holocron module by wrapping hocChain
 * mapStatetopRrops - convert the state to application properties
 * mapDispatchToProps - convert dispatch methods to   application properties
 * reducer - connect the reuder to redux
 * wrapper - calls one amex bundle script to register
 * loadInitialData -  loads all functions to be called before page rendering
 */

const hocChain = compose(
  oneAppModuleWrapper('axp-one-maps'),
  connectAsync({ loadDataAsProps }),
  withRouter);

MerchantMaps.holocron = {
  name: 'axp-one-maps',
  loadModuleData,
  reducer,
};

export default hocChain(MerchantMaps);
